import React, { useState } from "react";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";

const LotteryType = [
  {
    name: "original",
    type_3: [
      { name: "3 ตัวบน", type: "bon_3", rate: "1000" },
      { name: "3 ตัวโต๊ด", type: "tode_3", rate: "150" },
    ],
    type_2: [
      { name: "2 ตัวบน", type: "bon_2", rate: "100" },
      { name: "2 ตัวล่าง", type: "lang_2", rate: "100" },
    ],
    type_1: [
      { name: "วิ่งบน", type: "bon_1", rate: "3.20" },
      { name: "วิ่งล่าง", type: "lang_1", rate: "4.20" },
    ],
  },
  {
    name: "thai",
    type_3: [
      { name: "3 ตัวบน", type: "bon_3", rate: "1000" },
      { name: "3 ตัวโต๊ด", type: "tode_3", rate: "150" },
      { name: "3 ตัวหน้า", type: "na_3", rate: "450" },
      { name: "3 ตัวล่าง", type: "lang_3", rate: "450" },
    ],
    type_2: [
      { name: "2 ตัวบน", type: "bon_2", rate: "100" },
      { name: "2 ตัวล่าง", type: "lang_2", rate: "100" },
    ],
    type_1: [
      { name: "วิ่งบน", type: "bon_1", rate: "3.20" },
      { name: "วิ่งล่าง", type: "lang_1", rate: "4.20" },
    ],
  },
];

const specialOption = [
  { name: "19ประตู", specailOption: "19_door" },
  { name: "เลขเบิ้ล", specailOption: "double_number" },
  { name: "รูดหน้า", specailOption: "front_number" },
  { name: "รูดหลัง", specailOption: "back_number" },
  { name: "2ตัวต่ำ", specailOption: "low_number" },
  { name: "2ตัวสูง", specailOption: "high_number" },
  { name: "2ตัวคี่", specailOption: "odd_number" },
  { name: "2ตัวคู่", specailOption: "even_number" },
];

const Option = (props) => {
  return (
    <div className="relative">
      <button
        id={props.huayType}
        type="button"
        onClick={props.onClick}
        className={`w-full text-center bg-[#f8eede] grid grid-cols-12 border border-[#b3853e] md:text-lg rounded `}
      >
        <p id={props.huayType} className={`col-span-3 text-xl text-center `}>
          {props.option.filter((data) => data == props.huayType).length ? (
            <p id={props.huayType} className="text-[#b3853e] ">
              <CheckCircleRoundedIcon />
            </p>
          ) : (
            <p id={props.huayType} className="text-gray-500">
              <CheckCircleRoundedIcon />
            </p>
          )}
        </p>
        <p
          id={props.huayType}
          className={`col-span-9 rounded-r text-base py-1 font-bold
            ${
              props.option.filter((data) => data == props.huayType).length
                ? `text-[#b3853e]`
                : `text-gray-500 `
            } bg-white `}
        >
          {props.name}
          {" *"}
          {props.rate}
        </p>
      </button>
    </div>
  );
};

const OptionKlub = (props) => {
  // console.log(props);
  return (
    <div className="relative">
      <button
        onClick={() => props.setSpecial("reverse")}
        className={`w-full text-center bg-white grid grid-cols-12 border border-[#b3853e] md:text-lg rounded
      }`}
      >
        <div className="col-span-2 ">
          <p className="text-xl ml-x15 mt-0.5 ">
            {props.specialOption == "reverse" ? (
              <span className="text-[#b3853e] ">
                <CheckCircleRoundedIcon />
              </span>
            ) : (
              <span className="text-gray-500">
                <CheckCircleRoundedIcon />
              </span>
            )}
          </p>
        </div>
        <div className="col-span-10">
          <p
            className={`rounded-r text-base py-1 font-bold
            ${
              props.specialOption == "reverse"
                ? `text-[#b3853e] `
                : `text-gray-500`
            } `}
          >
            {props.type == 3 ? "ช่วยกลับเลขสามตัว" : "ช่วยกลับเลขสองตัว"}
          </p>
        </div>
      </button>
    </div>
  );
};

const HuayType = (props) => {
  return (
    <>
      <div className="rounded px-1 grid grid-cols-2 gap-1 pt-1">
        {props.lotteryName == "หวยรัฐบาลไทย" ? (
          props.type == "3" ? (
            LotteryType[1].type_3.map((type, i) => (
              <Option
                key={i}
                type={props.type}
                huayType={type.type}
                name={type.name}
                rate={type.rate}
                onClick={props.onClick}
                option={props.option}
              />
            ))
          ) : props.type == "2" ? (
            LotteryType[1].type_2.map((type, i) => (
              <Option
                key={i}
                type={props.type}
                huayType={type.type}
                name={type.name}
                rate={type.rate}
                onClick={props.onClick}
                option={props.option}
              />
            ))
          ) : props.type == "1" ? (
            LotteryType[1].type_1.map((type, i) => (
              <Option
                key={i}
                type={props.type}
                huayType={type.type}
                name={type.name}
                rate={type.rate}
                onClick={props.onClick}
                option={props.option}
              />
            ))
          ) : (
            <></>
          )
        ) : props.type == "3" ? (
          LotteryType[0].type_3.map((type, i) => (
            <Option
              key={i}
              type={props.type}
              huayType={type.type}
              name={type.name}
              rate={
                type.type != "tode_3"
                  ? type.rate
                  : type.rate
              }
              onClick={props.onClick}
              option={props.option}
            />
          ))
        ) : props.type == "2" ? (
          LotteryType[0].type_2.map((type, i) => (
            <Option
              key={i}
              type={props.type}
              huayType={type.type}
              name={type.name}
              rate={type.rate}
              onClick={props.onClick}
              option={props.option}
            />
          ))
        ) : props.type == "1" ? (
          LotteryType[0].type_1.map((type, i) => (
            <Option
              key={i}
              type={props.type}
              huayType={type.type}
              name={type.name}
              rate={type.rate}
              onClick={props.onClick}
              option={props.option}
            />
          ))
        ) : (
          <></>
        )}
      </div>

      <div className="rounded px-1 grid grid-cols-1 gap-1 pt-1">
        {props.type != "1" && props.type < "4" && props.openTab == "0" ? (
          <OptionKlub
            type={props.type}
            specialOption={props.specialOption}
            setSpecial={props.setSpecial}
          />
        ) : (
          <></>
        )}
      </div>

      <div
        className={`${
          props.openTab == "1" ? "hidden" : props.type == "2" ? `` : `hidden`
        }`}
      >
        <div className="w-auto rounded m-1 mb-0 grid grid-cols-4 gap-1 text-xs ">
          {specialOption.map((data, i) => (
            <button
              key={i}
              onClick={() => props.setSpecial(data.specailOption)}
              className="grid grid-cols-12 border border-defaultButtonType3 bg-defaultButtonNumberPlay rounded text-defaultPlayHuayDeactive"
            >
              {/* <div className="col-span-3 py-1 pt-1.5"> */}
                {/* {props.specialOption == data.specailOption ? (
                  <span className="text-[#b3853e] ">
                    <CheckCircleRoundedIcon />
                  </span>
                ) : (
                  <span className="text-[#b3853e]">
                    <CheckCircleRoundedIcon />
                  </span>
                )} */}
              {/* </div> */}
              <div className="col-span-12 bg-white rounded-r py-1.5 text-sm text-defaultPlayHuayDeactive font-bold hover:bg-[#FFD700] hover:border-[#D1B000]">
                {data.name}
              </div>
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default HuayType;
